import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { all_routes } from "../../../../router/all_routes";
import { useAbility } from "config/abilityContext";

const QuickAddDropdown = () => {
  const { t } = useTranslation();
  const routes = all_routes;
  const ability = useAbility();

  return (
    <div className="dropdown pe-1">
      {/* Dropdown Toggle Button */}
      <Link
        to="#"
        className="btn btn-outline-light bg-white btn-icon me-1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="ti ti-square-rounded-plus" />
      </Link>

      {/* Dropdown Menu */}
      <div className="dropdown-menu dropdown-menu-end border shadow-sm dropdown-md">
        <div className="p-3 border-bottom">
          <h5>{t("add")}</h5>
        </div>
        <div className="p-3 pb-0">
          <div className="row gx-2">
            {/* Add Student */}
            {ability.can("create", "Student") && ability.can("getAll", "Student") &&
              <div className="col-6">
                <Link to={routes.addStudent} className="d-block bg-primary-transparent rounded p-2 text-center mb-3 class-hover">
                  <div className="avatar avatar-lg mb-2">
                    <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-primary rounded-circle">
                      <i className="ti ti-school" />
                    </span>
                  </div>
                  <p className="text-dark">{t("student")}</p>
                </Link>
              </div>
            }

            {/* Add Teacher */}
            {ability.can("create", "Teacher") && ability.can("getAll", "Teacher") &&
              <div className="col-6">
                <Link to={routes.addTeacher} className="d-block bg-success-transparent rounded p-2 text-center mb-3 class-hover">
                  <div className="avatar avatar-lg mb-2">
                    <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
                      <i className="ti ti-users" />
                    </span>
                  </div>
                  <p className="text-dark">{t("teacher")}</p>
                </Link>
              </div>
            }

            {/* Add guardians */}
            {ability.can("create", "Guardian") && ability.can("getAll", "Guardian") &&
              <div className="col-6">
                <Link to={`${routes.guardiansList}?showAddModal=true`} className="d-block bg-warning-transparent rounded p-2 text-center mb-3 class-hover">
                  <div className="avatar avatar-lg mb-2">
                    <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-warning rounded-circle">
                      <i className="ti ti-user-shield" />
                    </span>
                  </div>
                  <p className="text-dark">{t("guardian")}</p>
                </Link>
              </div>
            }

            {/* Add class */}
            {ability.can("create", "Class") && ability.can("getAll", "Class") &&
              <div className="col-6">
                <Link to={`${routes.classes}?showAddModal=true`} className="d-block bg-info-transparent rounded p-2 text-center mb-3 class-hover">
                  <div className="avatar avatar-lg mb-2">
                    <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-info rounded-circle">
                      <i className="ti ti-school-bell" />
                    </span>
                  </div>
                  <p className="text-dark">{t("class")}</p>
                </Link>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickAddDropdown;
